import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "center-wrapper" }
const _hoisted_2 = { class: "sticky" }

import { useI18n } from 'vue-i18n'
import LanguageButton from '@/blocks/languageButton.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'languageButtonStandalonePage',
  props: {
    stickyHeight: {},
    align: {}
  },
  setup(__props: any) {

const { locale } = useI18n()



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "language-button-container",
      style: _normalizeStyle({ height: `${__props.stickyHeight ?? 500}px`, textAlign: __props.align ?? 'left' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(LanguageButton, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(locale) === 'sl' ? 'English' : 'Slovensko'), 1)
          ]),
          _: 1
        })
      ])
    ], 4)
  ]))
}
}

})